import { render, staticRenderFns } from "./edition-results.vue?vue&type=template&id=d54b7722&scoped=true&"
import script from "./edition-results.vue?vue&type=script&lang=ts&"
export * from "./edition-results.vue?vue&type=script&lang=ts&"
import style0 from "./edition-results.vue?vue&type=style&index=0&id=d54b7722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54b7722",
  null
  
)

export default component.exports